import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const r = {
  display: "block"
}, h = ({ size: e = 16, useVw: t, useRem: n, color: l, withColor: o, removeClassName: c, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-chuangxinjiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: c ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: c ? "" : "32px-åæ°äº¤æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: c ? "" : "normal",
        fill: o ? d(l, 0, "#262933") : "#262933",
        datafollowfill: o ? d(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.89 3.66a12.188 12.188 0 0 0-.312-.004v.034C9.09 3.69 3.814 8.878 3.672 15.332a.962.962 0 0 0-.038.268v.012c.006 6.591 5.351 11.933 11.944 11.933v-.042a2.542 2.542 0 0 0 1.185-.064 8.253 8.253 0 0 1-1.546-2.206 3.615 3.615 0 0 1-.228-.204c-.474-.458-.975-1.162-1.434-2.089-.812-1.641-1.438-3.874-1.568-6.379h4.204a8.283 8.283 0 0 1 2.172-1.922h-6.377c.123-2.511.72-4.746 1.517-6.386.449-.924.944-1.624 1.42-2.078.425-.407.772-.56 1.016-.591.09.003.18.008.268.013.239.051.558.212.941.578.476.454.971 1.154 1.42 2.078.713 1.469 1.266 3.415 1.463 5.61a8.197 8.197 0 0 1 1.893-.394c-.232-2.321-.83-4.414-1.627-6.055a12.068 12.068 0 0 0-.483-.9 10.036 10.036 0 0 1 5.648 7.417 8.217 8.217 0 0 1 2.047 1.093c-.287-6.042-5.063-10.909-11.067-11.338a2.717 2.717 0 0 0-.553-.027Zm-3.304 2.336c-.292.43-.564.906-.812 1.418-.929 1.912-1.587 4.438-1.712 7.225H5.567a10.065 10.065 0 0 1 7.02-8.643Zm-2.523 10.565H5.6a10.031 10.031 0 0 0 7.037 8.623 11.81 11.81 0 0 1-.806-1.391c-.945-1.91-1.638-4.437-1.77-7.232Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M23 16.9c-1.466 0-2.834.236-3.87.65-.515.206-.992.474-1.355.817-.366.346-.675.83-.675 1.433 0 .603.31 1.087.674 1.432.364.344.841.612 1.356.818 1.036.414 2.404.65 3.87.65 1.466 0 2.834-.236 3.87-.65.515-.206.992-.474 1.355-.818.366-.345.675-.829.675-1.432s-.31-1.087-.675-1.433c-.363-.343-.84-.61-1.355-.817-1.036-.414-2.404-.65-3.87-.65Zm-3.989 2.775a.548.548 0 0 0-.105.125.548.548 0 0 0 .105.124c.143.136.398.299.788.454.774.31 1.905.522 3.201.522s2.427-.212 3.201-.521c.39-.156.645-.32.788-.455a.544.544 0 0 0 .105-.124.544.544 0 0 0-.105-.125c-.143-.135-.398-.298-.788-.454-.774-.31-1.905-.521-3.201-.521s-2.427.212-3.201.521c-.39.156-.645.32-.788.454Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M18 23.9a.9.9 0 0 1 .9.887.46.46 0 0 0 .111.137c.143.136.398.299.788.454.774.31 1.905.522 3.201.522 1.176 0 2.22-.174 2.986-.441a3.43 3.43 0 0 0 .864-.421c.186-.135.24-.227.25-.251a.9.9 0 0 1 1.8.013c0 .212-.04.415-.11.605-.172.469-.519.827-.886 1.092-.375.27-.831.49-1.326.662-.991.345-2.242.54-3.578.54-1.466 0-2.834-.235-3.87-.65-.515-.205-.992-.473-1.355-.817-.366-.345-.675-.829-.675-1.432a.9.9 0 0 1 .9-.9Z"
        }
      )
    )
  )));
}, E = h;
export {
  E as default
};
